import { render } from "./button_item.vue?vue&type=template&id=6ed0d8a7&scoped=true"
import script from "./button_item.vue?vue&type=script&lang=js"
export * from "./button_item.vue?vue&type=script&lang=js"

import "./button_item.vue?vue&type=style&index=0&id=6ed0d8a7&scoped=true&lang=css"

import exportComponent from "/home/kabull/js/vue/iqtest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed0d8a7"]])

export default __exports__